// src/belediye/utils/meImzasi.js
// FAZ-80 — /me YANITININ İMZASI (yetki/bayrak durumunun parmak izi).
//
// NEDEN VAR. `authzSetFromMe` reducer'ı slice'ı her seferinde baştan yazar;
// Immer bu yüzden veri BİREBİR AYNI olsa bile YENİ bir nesne üretir. useSelector
// referans eşitliğine baktığından "hiçbir şey değişmedi" durumunda da bütün
// authz tüketicileri (ve BelediyeApp) yeniden çiziliyordu.
//
// Bu ucuz görünen yeniden çizim ciddi bir kusurun tetiği oldu: yerel dosya
// penceresi açılıp kapanınca `focus` ateşleniyor → /me tazeleniyor → dispatch →
// BelediyeApp çiziliyor → (o zamanlar gövde-içi tanımlı olan) route kabukları
// kimlik değiştirdiği için AÇIK SAYFA SÖKÜLÜYORDU. Kullanıcı bunu "fotoğrafı
// seçince sayfa yenilendi, ek gitti" olarak yaşıyordu.
//
// Kabuk kusuru BelediyeApp'te giderildi; burası ikinci savunma hattı: yanıt
// değişmediyse dispatch HİÇ yapılmaz, yani hiçbir şey yeniden çizilmez.
// Bayrak/izin GERÇEKTEN değiştiyse imza değişir ve tazeleme eskisi gibi işler.
//
// NOT: JSON.stringify anahtar sırasını KORUR, sıralamaz. Backend'in sözlük
// sırası (enabled_modules/enabled_features) değişirse aynı veri farklı metin
// üretir ve boşuna dispatch olur — bu yüzden anahtarlar burada sıralanıyor.

const siraliJson = (o) => {
  if (!o || typeof o !== "object") return JSON.stringify(o ?? null);
  if (Array.isArray(o)) return `[${o.map(siraliJson).join(",")}]`;
  return `{${Object.keys(o)
    .sort()
    .map((k) => `${JSON.stringify(k)}:${siraliJson(o[k])}`)
    .join(",")}}`;
};

// Alanlar authzSlice.authzSetFromMe'nin SAKLADIĞI alanlarla birebir aynı olmalı;
// slice yeni bir alan saklamaya başlarsa buraya da eklenmeli, yoksa o alanın
// değişimi sessizce yutulur.
export const meImzasi = (me) =>
  siraliJson({
    permissions: [...(Array.isArray(me?.permissions) ? me.permissions : [])].sort(),
    scope: me?.scope ?? null,
    global_role: me?.global_role ?? null,
    enabled_modules: me?.enabled_modules ?? {},
    enabled_features: me?.enabled_features ?? {},
    active_unit: me?.active_unit ?? null,
    is_superuser: me?.is_superuser === true,
    ui_profile: me?.ui_profile ?? null,
  });

export default meImzasi;
